export default "https://housescan.app.solease.nl/static/media/cavity_insulation_2.6653950c.svg";